import Heading from 'components/Heading'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

const MoreInfoContent = ({ canShowUploadInfo }) => {
  const { t } = useTranslation()

  return (
    <div className="baplie-or-restow__more-info-content">
      <Heading hasNoMarginBottom isDark level={4}>
        {t(
          'portCall.shipOverview.baplieOrRestowInfo.loadDischargeRestowSectionTitle'
        )}
      </Heading>
      {canShowUploadInfo && (
        <>
          <Text>
            {t(
              'portCall.shipOverview.baplieOrRestowInfo.loadDischargeRestowSectionDescription'
            )}
          </Text>

          <Text isBold>
            {t(
              'portCall.shipOverview.baplieOrRestowInfo.uploadProcessTitleNew'
            )}
          </Text>
          <Text style={{ whiteSpace: 'pre-line' }}>
            {t(
              'portCall.shipOverview.baplieOrRestowInfo.uploadProcessDescriptionNew'
            )}
          </Text>
        </>
      )}

      <Text isBold>
        {t('portCall.shipOverview.baplieOrRestowInfo.fileNameTitle')}
      </Text>
      <Text>
        {t('portCall.shipOverview.baplieOrRestowInfo.fileNameDescription')}
      </Text>

      <Text isBold>
        {t('portCall.shipOverview.baplieOrRestowInfo.deviceSyncStatusTitleNew')}
      </Text>
      <Text>
        {t('portCall.shipOverview.baplieOrRestowInfo.deviceSyncStatusIntro')}
      </Text>
      <Text style={{ whiteSpace: 'pre-line' }}>
        {`${t(
          'portCall.shipOverview.baplieOrRestowInfo.deviceSyncStatusBulletPendingNew'
        )}
${t(
  'portCall.shipOverview.baplieOrRestowInfo.deviceSyncStatusBulletCompletedNew'
)}
${t(
  'portCall.shipOverview.baplieOrRestowInfo.deviceSyncStatusBulletSkippedNew'
)}`}
      </Text>

      <Heading hasNoMarginBottom isDark level={4}>
        {t('portCall.shipOverview.baplieOrRestowInfo.historyViewTitle')}
      </Heading>
      <Text>
        {t(
          'portCall.shipOverview.baplieOrRestowInfo.historyViewDescriptionLine1Prefix'
        )}{' '}
        <strong>{t('portCall.shipOverview.viewHistory')}</strong>
        {t(
          'portCall.shipOverview.baplieOrRestowInfo.historyViewDescriptionLine1Suffix'
        )}
      </Text>
      <Text>
        {t(
          'portCall.shipOverview.baplieOrRestowInfo.historyViewDescriptionLine2'
        )}
      </Text>
    </div>
  )
}

MoreInfoContent.defaultProps = {
  canShowUploadInfo: false,
}

MoreInfoContent.propTypes = {
  canShowUploadInfo: PropTypes.bool,
}

export default MoreInfoContent
